import React, { useEffect, useState } from 'react';
import { IconButton, Typography } from '@mui/material';
import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

const BUTTON_SIZE = 40;

const ArrowStyle = styled(IconButton)(({ theme }) => ({
  width: BUTTON_SIZE,
  height: BUTTON_SIZE,
  cursor: 'pointer',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    color: theme.palette.text.primary,
  },
}));

const CategoryArrow = ({ onNext, onPrevious, sx, scrollContainerRef, previousText, nextText, isSiteBuilder}) => {
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;

    const checkScrollButtons = () => {
      if (!scrollContainer) return;

      const { scrollLeft, clientWidth, scrollWidth } = scrollContainer;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft + clientWidth < scrollWidth);
    };

    checkScrollButtons(); // Initial check

    // Add event listener to check scroll position on scroll
    scrollContainer.addEventListener('scroll', checkScrollButtons);

    // Cleanup the event listener on component unmount
    return () => {
      scrollContainer.removeEventListener('scroll', checkScrollButtons);
    };
  }, [scrollContainerRef]);

  return (
    <div style={{ position: 'relative', width: '100%', height: BUTTON_SIZE, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {/* Left Arrow (Previous) */}
      {(showLeftArrow || isSiteBuilder) && (
        <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', left: '10px' }}>
          
          <IconButton
            onClick={onPrevious}
            sx={{
              '& .arrow': { width: 28, height: 28, p: 0 },
              ...sx,
            }}
          >
            <ChevronLeftRounded className='arrow' />
          </IconButton>
          <Typography variant="body2" style={{ marginRight: '8px' }}>
            {previousText}
          </Typography>
        </div>
      )}

      {/* Right Arrow (Next) */}
      {(showRightArrow || isSiteBuilder) && (
        <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', right: '10px' }}>
         <Typography variant="body2" style={{ marginLeft: '8px' }}>
            {nextText}
          </Typography>
          <IconButton
            onClick={onNext}
            sx={{
              '& .arrow': { width: 28, height: 28, p: 0 },
              ...sx,
            }}
          >
            <ChevronRightRounded className='arrow' />
          </IconButton>
          
        </div>
      )}
    </div>
  );
};

CategoryArrow.propTypes = {
  onNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  sx: PropTypes.object,
  scrollContainerRef: PropTypes.object.isRequired, // Use object instead of shape
  previousText: PropTypes.string, // Added for previous text
  nextText: PropTypes.string, // Added for next text
};

CategoryArrow.defaultProps = {
  previousText: 'Previous', // Default text for previous arrow
  nextText: 'Next', // Default text for next arrow
};

export default CategoryArrow;
